import { Component, Inject, Input, LOCALE_ID, NgZone, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { TournamentInfoBoxComponent } from 'src/app/components/tournaments/tournament-info-box/tournament-info-box.component';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { TournamentService } from 'src/app/services/tournaments/tournament.service';
import { TOURNAMENTTYPE, Tournament, TournamentRankEntry } from 'src/app/services/tournaments/tournaments.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { LoggedStatus, UserInfo } from 'src/app/services/auth/login/login.models';
import { loginTrx } from 'src/app/router-translation.labels';
import { takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { WINDOW } from '@ng-web-apis/common';

@Component({
  selector: 'app-home-page-tournament-card',
  templateUrl: './home-page-tournament-card.component.html',
  styleUrls: ['./home-page-tournament-card.component.scss']
})
export class HomePageTournamentCardComponent extends TournamentInfoBoxComponent {
  myPosition: number;
  userInfo: UserInfo;
  rank: TournamentRankEntry[];
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    public router: Router,
    public tournamentDetailsService: TournamentDetailsService,
    public tournamentService: TournamentService,
    public detectDeviceService: DetectDeviceService,
    protected _ngZone: NgZone,
    protected loginStatusService: LoginStatusService,
    protected licenceService: LicenceService,
    @Inject(PLATFORM_ID) private platformId,
    private returnUrlService: DialogClosePreviousUrl,
    @Inject(WINDOW) readonly windowRef: Window,
    // private cloneService: ClonerService,
  ) { super(locale, router, tournamentDetailsService, tournamentService, detectDeviceService, _ngZone,licenceService) }

  @Input() routeURL;
  @Input() fromURL;
  @Input() ref: string;
  @Input() isEmbedded = false;
  @Input() isLarge: number = 0;
  minBetCurrency: string;
  minBet: number;
  isDesktop: boolean = this.detectDeviceService.isDesktop();

  ngOnInit(): void {
    const endDate = new Date(new Date().getTime() + (2 * 60 * 60 * 1000));
    if (this.isRegularTournament()?.tournamentType === TOURNAMENTTYPE.ACTIVE) {
      this.tournamentDetailsService.getTournamentState(this.isRegularTournament().ref).subscribe(resp => {
        this.isFinished = resp?.isFinished;
      })
    }
    if (!this.tournament?.isNetworkTournament && this.isRegularTournament()?.tournamentType !== TOURNAMENTTYPE.UPCOMMING) {
      this.tournamentDetailsService.getTournamentRank(this.isRegularTournament().ref).subscribe(resp => {
        this.rank = resp.rank;
        this.myPosition = resp.myPosition
      })
    }
    if (this.tournament?.isNetworkTournament) {
      if (new Date(this.tournament.endDate) < endDate) {
        this.isFinished = true;
      }
    }

    if (!!this.isRegularTournament()) {
      this.loginStatusService.getLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe(status => {
        if (status.isLogged === LoggedStatus.logged) {
          this.isLogged = true;
          const currency = status.currency;
          const minBetCurrencies = (this.tournament as Tournament).minBetCurrencies;
          if (minBetCurrencies && minBetCurrencies[currency.toLowerCase()]) {
            this.minBet = minBetCurrencies[currency.toLowerCase()];
            this.minBetCurrency = status.currency;
          }
          else {
            this.minBet = (this.tournament as Tournament).minBet;
            this.minBetCurrency = environment.baseCurrency;
          }
        }
        else {
          this.isLogged = false;
          this.minBet = (this.tournament as Tournament).minBet;
          this.minBetCurrency = environment.baseCurrency;
        }
      })
    }
  }

  login() {
    this.router.navigate(['', loginTrx], { state: { redirectTo: this.router.url } });
  }

  buttonClick() {
    this.returnUrlService.setUrl(this.router.url.split('/'), this.windowRef.scrollY);
  }
}
